<template>
  <v-container>
    <h2>Update role</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="role.role_name"
              label="Role name"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
          >
            <div>
              <header>Permission</header>
              <v-row>
                <v-col
                  v-for="(item, i) in permission_list"
                  :key="i"
                  cols="6"
                  md="3"
                >
                  <v-checkbox
                    v-model="role.permission"
                    :value="item.value"
                    :label="item.label"
                  />
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateRole"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'role-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "RoleEdit",
  components: { },
  data: () => ({
    role: {
      id: null,
      role_name: null
    },
    rules: {
      require: value => !!value || 'Please fill in information'
    },
    permission_list: [
      { label: 'Request', value: 'Request' },
      { label: 'Supporter', value: 'Supporter' },
      { label: 'Banner', value: 'Banner' },
      { label: 'User', value: 'User' },
    ]
  }),
  async mounted () {
    this.role.id = this.$route.params.id
    await this.getRole()
  },
  methods: {
    async getRole () {
      try {
        const { data } = await this.$http.get(`/back-office/roles/${this.role.id}`, authHeader())
        this.role.role_name = data.role_name
        this.role.permission = data.permission.split(',')
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateRole () {
      try {
        if (this.requireField()) {
          const role = {
            role_name: this.role.role_name,
            permission: this.role.permission.toString()
          }
          await this.$http.put(`/back-office/roles/${this.role.id}`, role, authHeader())
          this.$router.push({ name: 'role-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.role.role_name) {
        alert('Please fill in role name')
        return false;
      } else if (this.role.permission.length == 0) {
        alert('Please select at least one permission')
        return false
      }
      return true
    }
  },
};
</script>
